import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b67zcf7gz5: FaireBrandEntity = {
  token: "b_b67zcf7gz5",
  type: "brand",
  name: "Pink Stork",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4f9b0faf9ece616c699ec5ba1bc3b212815839bce4423fc72c9e067663891f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a97f3f06eaf4584afc7d65f62fc5939a3ae9d9fb4c466cf0fc4c656f98e26662.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f4f9b0faf9ece616c699ec5ba1bc3b212815839bce4423fc72c9e067663891f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a97f3f06eaf4584afc7d65f62fc5939a3ae9d9fb4c466cf0fc4c656f98e26662.png",
  location: "St. Augustine, FL, USA",
  minimumOrderDollars: 250,
  rating: 4,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Pink Stork, Founder and CEO, Amy Suzanne has seen it all. Her path to motherhood was filled with obstacles, including an infertility diagnosis, severe morning sickness, and a deathbed scare, all with military deployments complicating these challenges. But with faith in God, Amy knew she had a greater purpose, so she created Pink Stork to help other women. \n\nAs a mother of six, including one with Down syndrome, Amy is passionate about cultivating a business that is women-owned and run, where women, especially mothers, steer the course of the company. Pink Stork is here to bring you the best products, the best community, and a ton of hope, love, and support throughout your motherhood journey and beyond. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:22.015Z",
    importedBy: "entity-db-cli",
  },
};
